import { Outlet } from 'react-router-dom';

import { Logo } from '~ui/app/branding/logo';
import { Typography } from '~ui/base/typography';

/**
 * App shell — minimal header (just the wordmark) and a centred canvas. No
 * navigation, no auth, no account menu (DESIGN.md §13).
 */
function AppRoot() {
  return (
    <div className="min-h-full bg-background">
      <header className="border-b border-border/60 bg-background/80 backdrop-blur-sm">
        <div className="mx-auto flex max-w-canvas items-center justify-between px-8 py-5">
          <Logo />
          <Typography
            variant="caption-md"
            as="span"
            className="text-muted-foreground"
          >
            Dataset Search
          </Typography>
        </div>
      </header>
      <main className="mx-auto max-w-canvas px-8">
        <Outlet />
      </main>
    </div>
  );
}

export { AppRoot };
